const EMPLOYEES_ENDPOINTS = {
  BASE: '/employees',
  FILTER_OPTIONS: '/employees/filter-options',
  /**
   * Installation-level contract settings for the Contract tab (own line `employee_record.contract`).
   * GET /employees/contract-settings
   */
  CONTRACT_SETTINGS: '/employees/contract-settings',
  /**
   * Most recent active contract for a given employee.
   * GET /employees/:employeeId/contracts/current
   */
  CONTRACTS_CURRENT: (employeeId: string) => `/employees/${employeeId}/contracts/current`,
  /**
   * Full contract history for a given employee.
   * GET /employees/:employeeId/contracts
   */
  CONTRACTS_LIST: (employeeId: string) => `/employees/${employeeId}/contracts`,
  /**
   * A specific contract by its UUID key (hc_uuid_key).
   * GET /employees/:employeeId/contracts/:contractUuidKey
   */
  CONTRACT_BY_UUID_KEY: (employeeId: string, contractUuidKey: string) =>
    `/employees/${employeeId}/contracts/${contractUuidKey}`,
  PARAMS: {
    SORT_BY: 'sortBy',
    SORT_ORDER: 'sortOrder',
    PAGE: 'page',
    LIMIT: 'limit',
  },
};

export default EMPLOYEES_ENDPOINTS;
